export enum VariantType {
  PREMIUM = 'premium',
  FREE = 'free',
}

export type Template =
  | {
      templateId?: string;
      eventType?: string;
      keywords: string[];
      categories: string[];
      [key: string]: unknown;
    }
  | undefined;

export type TemplateSet = {
  backgrounds?: Array<{
    media?: Array<{
      url: string;
    }>;
  }>;
  liners?: Array<{
    media?: Array<{
      url: string;
    }>;
  }>;
  envelopes?: Array<{
    blank?: string;
    // biome-ignore lint/style/useNamingConvention: existing error
    flap_down_image?: string;
  }>;
};
